import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent } from '@angular/material/paginator';
import { LeadsService } from 'src/app/_service/leads.service';
import { MiscService } from 'src/app/_service/misc.service';
import { HttpClient } from '@angular/common/http';
declare var $: any;
import { GlobalConstants } from '../../common/global-constants';
const apiUrlServ = GlobalConstants.openApiURL
@Component({
  selector: 'app-push-data-to-nimbus',
  templateUrl: './push-data-to-nimbus.component.html',
  styleUrls: ['./push-data-to-nimbus.component.css'],
  host: {
    "(click)": "pushData($event.target.id)"
  }
})
export class PushDataToNimbusComponent implements OnInit {

  perpage: number = 25; length: number = 0; pageEvent: PageEvent; loading: boolean = true; loading_spinner: boolean = false; uploading_spinner: boolean = false;
  leadStatus = []; leadStatus_copy = []; bds = []; bds_copy = []; circles = []; circles_copy = []; lead_sources = []; lead_sources_copy = []; treatments = []; treatments_copy = []; treatCategory = []; treatCategory_copy = [];
  start_date: string = ''; end_date: string = ''; userId: string; list_id = ''; lead_source: string; lead_status: string; bd: string; circle = ''; treatment = ''; lead_category_filter = ''; payment_mode: string;
  campaign_data: any; campaign_data_copy: any; listName: any; listName_copy: any; campaign_name_dropdown: boolean = false; campaign_name = '';
  end_date_dump = ''; dump_loading: boolean = false; dump_from_paging: number; dump_to_paging: number; dump_per_page: number; dump_total: number = 0; paging_html_dump: any = ''; date_range_dump: string = '';

  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  constructor(private sharedapi: SharedService, private leadapi: LeadsService, public miscapi: MiscService, private http: HttpClient) { }

  ngOnInit(): void {
    this.getbds(); this.getcircle(); this.getLeadSources(); this.getleadStatus(); this.getTreatment(); this.getTreatmentCategory();
    this.userId = localStorage.getItem('loginuserId');
  }

  async loadPushDataList() {
    this.loading_spinner = true;
    let qString = 'lead_source=' + this.lead_source + '&circle=' + this.circle + '&treatment=' + this.treatment + '&lead_status=' + this.lead_status + '&bd=' + this.bd + '&date_range=' + this.start_date + '-' + this.end_date + '&payment_mode=' + this.payment_mode + '&lead_category_filter=' + this.lead_category_filter;
    this.loading = true;
    this.paging_html_dump = "";
    await this.leadapi.getPushDataToNimbus(qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loading_spinner = false;
      if (data.status) {
        this.getApiData();
        this.dump_from_paging = data.data.from;
        if (this.dump_from_paging) {
          this.dump_to_paging = data.data.last_page;
          this.dump_per_page = data.data.per_page;
          this.dump_total = data.data.total;
          this.date_range_dump = data.data.date_range;
          this.paging_html_dump += '<div class="tableFixHead" style="overflow: scroll"><table class="table table-striped"><thead><tr class="text-center"><th>#</th><th>Page Number</th><th>Action</th></tr></thead><tbody>';
          for (let x: number = this.dump_from_paging; x <= this.dump_to_paging; ++x) {
            let from_text = 1;
            if (x > 1) {
              from_text = Number(((x - 1) * this.dump_per_page) + 1);
            }
            let to_text = Number(this.dump_per_page * x);
            if (this.dump_to_paging == x) {
              to_text = ((Number(((x - 1) * this.dump_per_page) + 1) - 1) + (this.dump_per_page - Number(Number(this.dump_per_page * x) - this.dump_total)));
            }
            this.paging_html_dump += "<tr class='text-center'><td>" + x + "</td><td>Page " + x + " (From " + from_text + " to " + to_text + ")</td>";
            if (this.list_id) {
              this.paging_html_dump += '<td><button type="button" class="btn btn-outline-primary" id="page_' + x + '"> <i class="material-icons">cloud_upload</i> Upload </button></td>';
            }
            this.paging_html_dump += "</tr>"
          }
          this.paging_html_dump += "</tbody><table></div>";
        } else {
          this.sharedapi.presentToast("No data Found.");
        }
      } else {
        this.sharedapi.presentToast(data.msg);
        this.dump_from_paging = 0;
        this.dump_to_paging = 0;
        this.dump_per_page = 0;
        this.dump_total = 0;
        this.paging_html_dump = "";
        this.date_range_dump = "";
      }
    }, error => {
      this.loading = false;
      this.loading_spinner = false;
      this.sharedapi.checkError(error);
    });
  }

  pushData(page) {

    let qString = 'lead_source=' + this.lead_source + '&circle=' + this.circle + '&treatment=' + this.treatment + '&lead_status=' + this.lead_status + '&bd=' + this.bd + '&date_range=' + this.start_date + '-' + this.end_date + '&payment_mode=' + this.payment_mode + '&lead_category_filter=' + this.lead_category_filter;
    if ('page' == page.split('_')[0]) {
      var confirm_upload = confirm("Are you sure you want to Upload Page " + page.split('_')[1] + " item?");
      if (confirm_upload) {
        $("#page_" + page.split('_')[1]).prop('disabled', true);
        this.uploading_spinner = true;
        this.http.get(apiUrlServ + "push-data-to-nimbus?page=" + page.split('_')[1] + '&userId=' + this.userId + '&list_id=' + this.list_id + "&" + qString).subscribe((res: any) => {
          if (res.status) {
            this.uploading_spinner = false;
            $("#page_" + res.page_no).hide();
            this.sharedapi.presentToast(res.msg);
          }
        });
      }
    }
  }

  async getleadStatus() {
    this.leadapi.getLeadStatus().subscribe((data: any) => {
      if (data.status) {
        this.leadStatus = data.data;
        this.leadStatus_copy = this.leadStatus;
      } else {
        this.leadStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getbds(status = 1) {
    this.leadapi.getbds(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getcircle() {
    this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getLeadSources() {
    this.leadapi.getLeadSources().subscribe((data: any) => {
      if (data.status) {
        this.lead_sources = data.data;
        this.lead_sources_copy = this.lead_sources;
      } else {
        this.lead_sources = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTreatment() {
    this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
        this.treatments_copy = this.treatments;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTreatmentCategory() {
    await this.miscapi.getTreat_Category().subscribe((data: any) => {
      if (data.status) {
        this.treatCategory = data.data;
        this.treatCategory_copy = this.treatCategory;
      } else {
        this.treatCategory = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  setSearchValue(type) {
    if (type == 'lead_source') {
      $("#leadsourceSearch").val('');
      $("#leadsourceSearch").focus();
      this.lead_sources = this.lead_sources_copy;
    } else if (type == 'lead_status') {
      $("#lead_status_Search").val('');
      $("#lead_status_Search").focus();
      this.leadStatus = this.leadStatus_copy;
    } else if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    } else if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    } else if (type == 'leadCategory') {
      $("#leadcategorySearch").val('');
      $("#leadcategorySearch").focus();
      this.treatCategory = this.treatCategory_copy;
    } else if (type == 'campaign_name') {
      $("#campaign_nameSearch").val('');
      $("#campaign_nameSearch").focus();
      this.campaign_data = this.campaign_data_copy;
    } else if (type == 'list_name') {
      $("#list_nameSearch").val('');
      $("#list_nameSearch").focus();
      this.listName = this.listName_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_source') {
      this.lead_sources = this.sharedapi.searchData(searchtText, this.lead_sources_copy, "source_name");
    } else if (type == 'lead_status') {
      this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
    } else if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    } else if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if (type == 'leadCategory') {
      this.treatCategory = this.sharedapi.searchData(searchtText, this.treatCategory_copy, "name");
    } else if (type == 'campaign_name') {
      this.campaign_data = this.sharedapi.searchData(searchtText, this.campaign_data_copy, "campaign_name");
    } else if (type == 'list_name') {
      this.listName = this.sharedapi.searchData(searchtText, this.listName_copy, "list_name");
    }
  }

  resetFilters() {
    this.clearDate();
    this.lead_source = ''; this.lead_status = ''; this.bd = ''; this.circle = ''; this.treatment = ''; this.lead_category_filter = ''; this.payment_mode = ''; this.campaign_name = ''; this.list_id = '';
    this.campaign_name_dropdown = false; this.dump_total = 0;
  }

  getApiData() {
    this.http.get('https://10.10.0.5/agc/push_details/get_list_info.php').subscribe(Response => {
      if (Response) {
        this.campaign_name_dropdown = true;
        this.campaign_data = Response;
        this.campaign_data_copy = this.campaign_data;
        this.listName = Response;
        this.listName_copy = this.listName;
      }
    });
  }


}
